var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 240",
    style: {
      enableBackground: "new 0 0 300 240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:#F2F2F2;}\n\t.st1{fill:#F2F2F2;}\n\t.st2{fill:#4E5BBC;}\n\t.st3{fill:#5B69CA;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;}\n\t.st6{fill:none;stroke:#41465A;stroke-linecap:round;}\n\t.st7{fill:#CACBD1;}\n\t.st8{fill:#41465A;}\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st10{fill:none;stroke:#41465A;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st11{fill:#FDB194;}\n\t.st12{fill:#D9DBDD;}\n\t.st13{fill:#CBCBCB;}\n\t.st14{fill:#303540;}\n\t.st15{fill:#4756A2;}\n\t.st16{fill:#EBA38C;}\n\t.st17{fill:#191847;}\n\t.st18{fill:none;}\n\t.st19{fill:#E9CA62;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.5,
    className: "st0",
    width: 300,
    height: 240
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.5,
    className: "st0",
    width: 300,
    height: 240
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.1,166.4c0,28.2-14.7,55.1-50.3,53.2c-10.3,0-18.2-0.1-25.3-0.1c-53.7,1.5-130.6,0.1-143.2,0.5l0,0 c-17.6,0.5-32.3-17.6-31.1-38c1.3-20.5,21.5-30.3,21.5-30.3s-13.6-33.7,5-58C70.4,69.4,97,80.5,97,80.5s11.8-46,51.3-47.2 c27-0.8,45.8,5.6,56.2,24.2c6.8,8.7,10.8,19.5,10.8,31.2c0,1,0,1.9-0.1,2.9c4.1-0.7,15-1.5,19.1,14.3c0,0,0.1,6.1,0.6,10.9 C258,122.1,275.1,142.3,275.1,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.3,95.5H177c4.2,0,7.6,3.5,7.6,7.8v109.4c0,4.3-3.4,7.8-7.6,7.8h-50.8c-4.2,0-7.6-3.5-7.6-7.8V103.3 C118.7,99,122.1,95.5,126.3,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61,43.8c9.5,0,17.3,7.9,17.3,17.7c0,9.8-7.7,17.7-17.2,17.8c-9.5,0-17.3-7.9-17.3-17.7c0,0,0,0,0-0.1 C43.8,51.8,51.5,43.9,61,43.8L61,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.3,57.8c-0.7,0.2-1.4,0.2-2.1,0.2c0.8-0.3,1.4-0.9,1.8-1.7c-0.7,0.3-1.5,0.4-2.3,0.5c-1-1.6-3.2-2.1-4.8-1 c-0.8,0.5-1.4,1.4-1.5,2.4c-0.1,0.3-0.1,0.5-0.1,0.8c-2.7-0.6-5.1-2.4-6.4-4.9c-1.2,1.4-1.1,3.6,0.2,4.9c-0.5-0.1-1-0.4-1.5-0.7v0 c-0.3,1.7,0.6,3.3,2.1,3.9c-0.3,0-0.6,0-0.9,0c-0.2,0-0.4-0.1-0.6-0.2c0.2,1.5,1.3,2.7,2.8,3c-1.4,0.7-3,1-4.5,0.7 c-0.3,0-0.5-0.1-0.8-0.2c1.4,1.3,3.1,2.2,5,2.5c5.3,1,10.4-2.6,11.4-8.1c0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.1-0.5 C69,58.9,69.7,58.4,70.3,57.8L70.3,57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.9,20.5c10.7,0,19.3,8.9,19.3,19.8s-8.7,19.8-19.3,19.8c-10.7,0-19.3-8.9-19.3-19.8 C100.6,29.3,109.3,20.5,119.9,20.5L119.9,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M121.6,40.3c0,1-0.7,1.7-1.7,1.8c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.8 C120.8,38.6,121.6,39.3,121.6,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.7,35l-5.7,0.1c-1.2,0-2.2,1.1-2.2,2.3l0.1,5.8c0,1.3,1,2.3,2.3,2.3l5.7-0.1c1.2,0,2.2-1.1,2.2-2.3 l-0.1-5.8C124.9,36,123.9,35,122.7,35z M120,43.2c-1.5,0-2.8-1.2-2.9-2.8c0-1.6,1.2-2.9,2.8-2.9c1.5,0,2.8,1.2,2.9,2.8 S121.5,43.1,120,43.2z M123.1,37.5c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.2-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6S123.4,37.5,123.1,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M124.3,30.4l-9.1,0.2c-2.8,0.1-5,2.4-5,5.3l0.2,9.3c0.1,2.9,2.4,5.1,5.1,5.1l9.1-0.2c2.8-0.1,5-2.4,5-5.3 l-0.2-9.3C129.4,32.6,127.1,30.3,124.3,30.4L124.3,30.4z M126.2,43.1c0,1.9-1.4,3.5-3.3,3.5l-5.7,0.1c-1.9,0-3.4-1.5-3.4-3.4 l-0.1-5.8c0-1.9,1.4-3.5,3.3-3.5l5.7-0.1c1.9,0,3.4,1.5,3.4,3.4L126.2,43.1L126.2,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.3,27.3c10.7,0,19.3,8.9,19.3,19.8S204.9,67,194.3,67s-19.3-8.9-19.3-19.8 C174.9,36.2,183.6,27.3,194.3,27.3L194.3,27.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M197.5,40.2h1.9v-3.3c-0.9-0.1-1.8-0.1-2.7-0.1c-2.7,0-4.5,1.7-4.5,4.9v2.9h-3v3.7h3v9.3h3.6v-9.3h2.8l0.4-3.7 h-3.3V42C195.7,40.9,196,40.2,197.5,40.2L197.5,40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.3,102.6c10.8-0.1,19.7,8.8,19.8,19.9c0.1,11.1-8.6,20.2-19.4,20.3s-19.7-8.8-19.8-19.9c0-0.1,0-0.1,0-0.2 C27.8,111.7,36.5,102.7,47.3,102.6L47.3,102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.1,122.5h9.1v-8.7c0-0.3-0.3-0.6-0.6-0.6h-8.5V122.5L48.1,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.9,122.5v-9.3h-8.5c-0.3,0-0.6,0.3-0.6,0.6v8.7H46.9L46.9,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.9,123.7h-9.1v8.7c0,0.3,0.3,0.6,0.6,0.6h8.5V123.7L46.9,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.1,123.7v9.3h8.5c0.3,0,0.6-0.3,0.6-0.6v-8.7H48.1L48.1,123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.8,73c9.5,0,17.3,7.9,17.3,17.7c0,9.8-7.7,17.7-17.2,17.8c-9.5,0-17.3-7.9-17.3-17.7c0,0,0,0,0-0.1 C230.6,81,238.3,73.1,247.8,73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M242.4,92.4l-0.7,2.5l-2.4,0.1c-1.5-2.8-1.5-6.1-0.1-8.9l2.1,0.4l0.9,2.2C241.9,89.8,242,91.2,242.4,92.4 L242.4,92.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256.8,88.6c0.6,3.5-0.6,7-3.3,9.2l-2.7-0.1l-0.4-2.4c1.1-0.7,1.9-1.7,2.4-2.9h-5v-3.8H256.8L256.8,88.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M253.4,97.9c-4,3.3-9.9,2.6-13.1-1.5c-0.4-0.5-0.7-0.9-0.9-1.5l3-2.5c1.1,2.9,4.3,4.4,7.1,3.3 c0.3-0.1,0.6-0.3,0.8-0.4L253.4,97.9L253.4,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M253.5,83.1l-3,2.5c-2.6-1.7-6-0.8-7.6,1.8c-0.2,0.4-0.4,0.8-0.5,1.2l-3-2.5c2.4-4.7,8-6.5,12.6-4.1 C252.5,82.2,253,82.6,253.5,83.1L253.5,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.5,109.6h38.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M164.4,109.6h6.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M144.5,204.7c0,0,5.5,7.9,12.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M168.9,119.1h101.7c1.4,0,2.5,1.2,2.5,2.6v37.1c0,1.4-1.1,2.6-2.5,2.6H168.9c-1.4,0-2.5-1.2-2.5-2.6v-37.1 C166.4,120.2,167.5,119.1,168.9,119.1L168.9,119.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.3,125v6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.7,128.5H227"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.7,126l-4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.9,126l4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M238.8,125v6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M242.2,128.5h-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M241.2,126l-4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236.4,126l4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249.6,125v6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M253,128.5h-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M252,126l-4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M247.2,126l4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M258.1,125v6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.4,128.5h-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M260.5,126l-4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M255.7,126l4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.9,125v6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.3,128.5h-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.3,126l-4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.5,126l4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M266.5,125v6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M269.9,128.5h-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M268.9,126l-4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M264.1,126l4.8,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214.6,139.9h-44c-0.5,0-0.8,0.4-0.8,0.9v3.5c0,0.5,0.4,0.9,0.8,0.9h44c0.5,0,0.8-0.4,0.8-0.9v-3.5 C215.4,140.3,215.1,139.9,214.6,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214.6,149.4h-44c-0.5,0-0.8,0.4-0.8,0.9v3.5c0,0.5,0.4,0.9,0.8,0.9h44c0.5,0,0.8-0.4,0.8-0.9v-3.5 C215.4,149.8,215.1,149.4,214.6,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.3,125c-0.5,0.2-1,0.4-1.6,0.5c0.6-0.4,1-0.9,1.2-1.6c-0.5,0.3-1.1,0.6-1.8,0.7c-1-1.1-2.8-1.2-3.9-0.1 c-0.6,0.5-0.9,1.3-0.9,2.1c0,0.2,0,0.4,0.1,0.7c-2.2-0.1-4.3-1.2-5.7-3c-0.7,1.3-0.4,3,0.9,3.8c-0.4,0-0.9-0.1-1.3-0.3v0 c0,1.4,0.9,2.5,2.2,2.8c-0.2,0.1-0.5,0.1-0.7,0.1c-0.2,0-0.4,0-0.5-0.1c0.4,1.2,1.4,2,2.6,2c-1,0.8-2.2,1.2-3.4,1.2 c-0.2,0-0.4,0-0.7,0c1.3,0.8,2.8,1.3,4.3,1.3c4.3,0,7.9-3.6,7.9-8c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.4 C182.4,126,182.9,125.5,183.3,125L183.3,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M263.7,152.9c3.3,0,5.9-2.7,5.9-6.1c0-3.4-2.7-6.1-5.9-6.1s-5.9,2.7-5.9,6.1 C257.8,150.2,260.4,152.9,263.7,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M262.5,143.2v4.3h4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M184.1,190.9c7.9,0,14.3,6.6,14.3,14.7c0,8.1-6.4,14.7-14.3,14.7c-7.9,0-14.3-6.6-14.3-14.7 C169.8,197.4,176.2,190.9,184.1,190.9L184.1,190.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M190.2,199.7c0,0-2.9-4.5-9-2.3c0,0-6,2.3-4.9,9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M173.8,203.4l2.4,3.8l3.2-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M178.6,212c0,0,2.9,4.5,9,2.3c0,0,6-2.3,4.9-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M194.9,208.3l-2.4-3.8l-3.2,3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M107.6,186.3l4.4,1.8c0,0,0.6-0.9,0.6-8.2c0-0.2-5,0-5,0V186.3L107.6,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M103.5,209.3l-1.8,4.5c0,0,0.8,0.6,7.9,0.7c0.2,0,0-5.1,0-5.1H103.5L103.5,209.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M101.9,213.4c0,0.1-5.5,2.7-8.3,4.1c-1,0.5-1.6,1.5-1.6,2.6h18.1l-0.4-6.1C109.7,214,102.4,214.4,101.9,213.4 L101.9,213.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M111.6,189.3c0.1,0,2.7,5.6,4,8.5c0.4,1,1.4,1.6,2.5,1.6v-18.5l-5.9,0.4C112.2,181.3,112.6,188.7,111.6,189.3 L111.6,189.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M98.1,141.6c0,0-12,21.7-12.2,22.2c-0.2,0.5-1.5,1.9-0.9,7c0.6,5.1,14.3,14,14.3,14s6.2,2.8,6.5,3.1 c0.2-0.9,0.2-4.4,0-8.4c-3.1-5.7-8.8-10-8.8-10l7.8-10.1L98.1,141.6L98.1,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M117.5,136.3c0,0,0.2,5.2,0,10c-0.3,3.6-0.7,7.2-1.4,10.8l-6.5,53c0,0-5.9,0.4-6.3-0.6 c-1.1-13.3-3.8-52.4-3.8-52.4l-2.3-17L117.5,136.3L117.5,136.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M115.1,142.5c0,0-9.4-1.1-17.5-0.2l-0.2-1.2l19.6-1.4l-1.6,2.5L115.1,142.5L115.1,142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M96.8,130.2c0,0-3.9-0.1-4.4-0.6c-0.5-0.6-11-11.1-11-12.5c0-1.5,0-5,0-5s-0.9-0.3-0.9,0.5 c-0.1,1.1-0.3,2.2-0.5,3.2c0,0-3.4-4.1-4-4.4c-0.3-0.1-0.7-0.1-0.9,0.2c0,0-0.4,0.8,0,1.2c0.8,0.8,1.6,1.6,2.2,2.6 c0.1,0.6-2.9,2-2.6,2.8c0.6,2.1,1.1,0.5,5,5.6c3.8,5.1,8.8,10.9,9.9,11.6c0.9,0.6,1.9,0.9,2.9,1c0.9,0,2.8-1.8,2.8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M118.1,119.5c-0.5-0.7,0.8,6.4,2.5,12.2c1.7,5.7,5.8,8,6.7,5c-0.5-8.4-1.8-12.1-3.4-17.6 C123.8,119.2,118.6,120.2,118.1,119.5L118.1,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.6,142.6c-3.4-0.9-6.9-1.4-10.4-1.4H105c-2.9,0.1-5.3,0.3-6.9,0.4c-0.6,0.1-1.2-0.4-1.2-1 c0-0.1,0-0.2,0-0.4l1.7-8c1.1-5.2,1.1-10.5-0.1-15.7l-1-4.3c-0.1-0.6,1.8-3.7,2.2-4.3c0.5-0.2,1-0.4,1.6-0.5 c0.9-0.2,1.8-0.4,2.7-0.5l5.3-0.6c3.6-0.5,9.1,1.3,9.3,1.5v0c0,0,4.8,4.1,5.4,7.8c0.4,1.7,0.5,3.4,0.4,5.1c-2.1,0.7-4.3,0.7-6.4,0 c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0.4-0.1,0.9-0.2,1.3c-0.5,3-0.8,6.1-0.4,9.1c0.6,4.9,1.3,11.4,1.1,11.5c-0.1,0.1-0.2,0.1-0.3,0.1 C117.9,142.7,117.7,142.7,117.6,142.6L117.6,142.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M118.1,121.1c0,0,3.3,1.4,6.5,0.6l-0.2-0.7l-6.3-0.1L118.1,121.1L118.1,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M106.4,146.5c0,0,6.6,2.4,9.8,8l-8-0.2L106.4,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M126.8,137.4c-0.9,2.1-11.5,14.3-13.2,14.7c0.1-0.1-1.2,4.2-2.2,4.5c-1,0.3,0.4-2.6,0.4-2.6l-0.3,0.2 c0,0-1.5,2.3-2,2.3c-0.4,0.1-0.8-0.2-0.5-0.9c0.6-0.9,1.2-1.8,1.8-2.6c0,0-2.8,2.6-3.1,2.5c0,0-0.7-0.2-0.4-0.8 c0.9-1.1,1.8-2.1,2.8-3c0,0-3.1,2.4-3.4,2c0.1,0.1-0.8-0.3-0.1-1.3c0.8-0.9,2.9-3.4,2.9-3.4s0.1-0.4-0.4-0.3 c-0.8,0-1.6-0.2-2.4-0.4c0,0-0.9-0.5,0-0.9c0-0.1,2,0.1,2.4,0c1.2-0.6,2.3-1.2,3.3-2l9.9-11.2C122.4,134.3,127.6,135.3,126.8,137.4 L126.8,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M106.4,146.2c0,0,4.4,5.8,9.7,8.1c-0.2-0.1-7.3,5.8-9.7,3.7S106.4,146.2,106.4,146.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M99.6,119.5c0.5-0.6-0.7,5.8-2.3,11.1c-1.6,5.2-5.3,7.3-6.1,4.6c0.5-7.7,1.7-11,3.1-16 C94.4,119.2,99.1,120.1,99.6,119.5L99.6,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M99.5,121.6c0,0-1.5,1.3-6.1,0.7l0.3-0.9L99.5,121.6L99.5,121.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.8,108.1c-1.5-1.3-5.9,4.7-6.6,8.3c-0.6,3.6-1.4,4.8-1.1,4.9c2.4,0.7,4.9,0.7,7.3,0 C103.5,120.2,102.3,109.4,100.8,108.1L100.8,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M116.1,90.4v6.2c0,4.9-3.5,9-8.2,9.7c0,0,0,0.1,0,0.1H95.6c-2.1-2,0.3-15.2,1.8-19.6c0.4-1.1,0.8-1.7,1.1-1.8 c2.9-4.6,8.8-5.9,13.3-2.9C114.5,83.9,116.2,87,116.1,90.4L116.1,90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M113.7,88.1c0.1,2.5-0.7,4.9-2.3,6.8c0.8,4.4,2.3,12.2,2.5,13.6c0.2,1.9-7.7,0-7.7,0l1.4-10.1 c-2.1,1.4-4.2,2-5.2,1.8c-2.5-0.7-2.7-10.2-0.8-14c0.9-1.8,3.8-3.2,6.4-3.2C110.8,82.9,113.4,84.3,113.7,88.1L113.7,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M115.8,88.3c-0.3-0.3-0.6-0.6-0.9-0.8v-0.3c-0.6-1.1-1.4-2.2-2.2-3.1c-0.8-0.8-1.6-1.6-2.6-2.1 c-1-0.6-2.2-1-3.4-1c-1.8-0.1-3.7,0.4-5.3,1.3c-1,0.7-1.9,1.6-2.6,2.7c0.3,1.1,1,2,2,2.6c1,0.7,2.1,1.2,3.2,1.6 c1.1,0.4,2.1,1,3.1,1.5c0.4-0.3,0.9-0.5,1.5-0.5c1.2,0,2.3,0.9,2.4,2.2c-0.1,1.3-1.1,2.3-2.4,2.2h-0.1c-0.2,2.4-0.3,4.7-0.1,7.1 c0.1,1.6,0.4,3.7,1.3,4.5h12.4c0.1-1.2,0.1-2.5-0.1-3.7c-0.1-0.9-0.3-1.7-0.6-2.5c-0.5-1.2-1.3-2.2-2.2-3.1 C119.2,97,115.3,94.3,115.8,88.3L115.8,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M106.3,106.9c0,0-1.2,3.1-0.5,5c0.7,1.8,3.1,2.4,3.1,2.4s2.7,0.9,4.2-0.9c1.5-1.8,0.5-6.4,0.5-6.4 L106.3,106.9L106.3,106.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.9,
    y: 139.1,
    className: "st18",
    width: 35.5,
    height: 36.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6633",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    className: "st2",
    d: "M143.2,139h12.9c1.3,0,2.7,0.3,3.9,0.8c2.4,1,4.3,3,5.4,5.4c0.5,1.2,0.8,2.6,0.8,3.9v12.9 c0,1.3-0.3,2.7-0.8,3.9c-1,2.4-3,4.3-5.4,5.4c-1.2,0.5-2.6,0.8-3.9,0.8h-12.9c-1.3,0-2.7-0.3-3.9-0.8c-2.4-1-4.3-3-5.4-5.4 c-0.5-1.2-0.8-2.6-0.8-3.9v-12.9C133.1,143.5,137.6,139,143.2,139C143.1,139,143.1,139,143.2,139L143.2,139"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    className: "st4",
    d: "M142.2,165.8c1,0.8,2.2,1.4,3.4,1.9c3.7,1.3,7.9,0.7,11.1-1.6c0.1-0.1,0.2-0.2,0.4-0.2 c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1,0,0.3,0,0.4 c0,0.3-0.2,0.5-0.5,0.6c-5,3.7-11.9,3.6-16.8-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0-0.4 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.3,0,0.4,0C141.9,165.7,142.1,165.7,142.2,165.8 L142.2,165.8z M163.9,155.1v0.5c0,0.9-0.1,1.8-0.2,2.6c-0.1,0.9-0.4,1.7-0.7,2.5c-0.6,1.7-1.5,3.2-2.6,4.6 c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.2,0.2-0.3c1.3-1.5,2.2-3.3,2.7-5.3c0.3-1,0.3-2.1,0.3-3.1v-0.3 c0-0.1,0-0.3,0-0.4c0-0.1,0.1-0.2,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.3,0,0.4,0 c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.3,0.3C163.8,154.8,163.9,154.9,163.9,155.1L163.9,155.1z M137.5,158.9 c0.1,0.4,0.3,0.8,0.4,1.3c0.2,0.4,0.3,0.8,0.5,1.2c0.2,0.4,0.4,0.8,0.6,1.2c0.2,0.4,0.5,0.7,0.7,1.1c0.1,0.1,0.2,0.2,0.2,0.3 c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.4-0.6-0.8-0.9-1.3c-0.3-0.4-0.5-0.9-0.8-1.4c-0.2-0.5-0.4-0.9-0.6-1.4 c-0.2-0.5-0.3-1-0.5-1.5c-0.1-0.3,0-0.6,0.1-0.8c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.2,0.4-0.2c0.1,0,0.3,0,0.4,0 c0.1,0,0.2,0.1,0.3,0.2C137.3,158.4,137.5,158.6,137.5,158.9L137.5,158.9z M154.2,147.6c1,0.6,1.9,1.5,2.6,2.5 c1.4,2,2,4.4,1.6,6.8c-0.6,3.7-3.3,6.7-6.9,7.6c-1.1,0.3-2.3,0.3-3.5,0.2c-1.2-0.2-2.4-0.6-3.4-1.3c-1-0.6-1.9-1.5-2.6-2.5 c-1.7-2.3-2.2-5.3-1.3-8.1c0.3-1,0.8-2,1.5-2.8c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.4-0.5,0.7-0.8c0.2-0.3,0.5-0.5,0.8-0.7 c0.3-0.2,0.6-0.4,0.9-0.6c0.2-0.1,0.5-0.2,0.8-0.1c0.1,0,0.2,0.1,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.3,0.2,0.5,0.1,0.8 c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-1.6,1-2.7,2.6-3.1,4.5c-0.4,1.8-0.1,3.8,0.9,5.4c2,3.3,6.2,4.3,9.5,2.4 c0.1,0,0.1-0.1,0.2-0.1c1.6-1,2.7-2.6,3.1-4.5c0.4-1.8,0.1-3.8-0.9-5.4c-0.1-0.2-0.3-0.5-0.5-0.7c-0.2-0.2-0.4-0.4-0.6-0.6 c-0.2-0.2-0.4-0.4-0.6-0.6s-0.4-0.4-0.7-0.5c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.1,0-0.3,0-0.4 c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0C154,147.4,154.1,147.5,154.2,147.6 L154.2,147.6z M143.9,143c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.3 c-1,0.6-1.8,1.2-2.6,2c-1.6,1.6-2.7,3.6-3.3,5.7c-0.3,1.1-0.4,2.2-0.4,3.3c0,0.1,0,0.3-0.1,0.4c-0.1,0.3-0.3,0.5-0.6,0.6 c-0.2,0.1-0.5,0.1-0.8,0c-0.2-0.1-0.4-0.3-0.6-0.6c-0.1-0.1-0.1-0.3-0.1-0.4c0-2.6,0.7-5.2,2-7.5c0.6-1.1,1.4-2.2,2.3-3.1 c0.9-0.9,1.9-1.8,3.1-2.4c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.4,0.2C143.7,142.7,143.8,142.8,143.9,143 L143.9,143z M156,142.3c0.9,0.5,1.7,1,2.5,1.6c0.8,0.6,1.5,1.3,2.1,2.1c0.6,0.8,1.2,1.6,1.6,2.5c0.5,0.9,0.8,1.8,1.1,2.7 c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.8-0.5-1.6-0.9-2.4c-0.4-0.7-0.9-1.5-1.4-2.1 c-0.5-0.7-1.1-1.3-1.8-1.8c-0.7-0.6-1.4-1-2.1-1.5c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.1,0-0.3,0-0.4 c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.3-0.1,0.4-0.1C155.8,142.2,155.9,142.2,156,142.3 L156,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    className: "st19",
    d: "M149.6,140.8c0.3,0,0.5,0.1,0.7,0.3c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.4v8.9 c0,0.5,0.2,0.9,0.6,1.1c0.4,0.2,0.7,0.4,1,0.7c0.5,0.4,0.8,1,1,1.6c0.2,0.7,0.4,1.4,0.4,2.1c0,0.9-0.1,1.8-0.3,2.6 c-0.1,0.3-0.2,0.5-0.4,0.6c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1,0-0.3,0-0.4,0c-0.3-0.1-0.5-0.2-0.6-0.4c-0.1-0.1-0.1-0.2-0.2-0.4 c0-0.1,0-0.3,0-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2h-1.3c-0.1,0-0.3,0-0.4-0.1 c-0.3-0.1-0.5-0.3-0.6-0.6c-0.1-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2 c0.1-0.1,0.3-0.1,0.4-0.1h1.4c0-0.3,0-0.6-0.1-0.8c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2-0.2-0.4-0.4-0.6-0.5c-0.3-0.1-0.5-0.3-0.8-0.3 c-0.2,0-0.3,0.1-0.5,0.2c-0.3,0.2-0.6,0.4-0.8,0.7c-0.1,0.1-0.2,0.3-0.3,0.5c-0.1,0.3-0.2,0.6-0.2,0.9c-0.1,0.3-0.1,0.6-0.1,0.9 c0,0.3,0,0.6,0,1c0,0.3,0.1,0.7,0.1,1c0.1,0.3,0,0.6-0.1,0.8c-0.1,0.3-0.4,0.5-0.7,0.5c-0.3,0.1-0.6,0-0.8-0.1 c-0.3-0.1-0.5-0.4-0.5-0.7V159c-0.2-0.9-0.2-1.8-0.2-2.7c0-0.7,0.2-1.4,0.4-2.1c0.3-1,1-1.8,1.9-2.3c0.4-0.2,0.7-0.7,0.7-1.1v-6 l-1.2,0.1c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.3-0.1-0.4 c0-0.3,0.1-0.5,0.3-0.7c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.4-0.1l1.4-0.1V142c-0.1-0.1-0.1-0.3-0.1-0.5 c0-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.3C149.3,140.9,149.4,140.8,149.6,140.8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.7171258d43fa239d0036bfdf804d386e.svg";
export { ForwardRef as ReactComponent };